export const COSPACE_PROD = 'https://cospace.app/app.php';
export const COSPACE_DEV = 'https://dev.cospace.app/app.php';
export const COSPACE_RC = 'https://rc.cospace.app/app.php';
